import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { first } from 'rxjs/operators';
import { ApiService } from 'src/_services/api.service';
declare var $: any;

@Component({
  selector: 'app-family-allowance-list',
  templateUrl: './family-allowance-list.component.html',
  styleUrls: ['./family-allowance-list.component.scss']
})
export class FamilyAllowanceListComponent implements OnInit {

  value: any;
  rsubmitted: boolean = false;
  responseFamilyAllowance: any;
  response: any;
  userDetails: any;
  allowanceData: any
  uuid: any;
  result: any;
  currentUser:any;

  constructor(private location: Location,
    private ngxUiLoaderService: NgxUiLoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService) {
    const data = localStorage.getItem('currentUserDetails');

    if (data) {
      this.userDetails = JSON.parse(data);
      console.log("user details:", this.userDetails);
      console.log("user details:", this.userDetails.uuid);
      this.currentUser = this.userDetails.current_user;
      this.alloWanceList();
    }
    if (this.route.snapshot.paramMap.get('id')) {
      this.uuid = this.route.snapshot.paramMap.get('id');
      console.log("uuuuuuuuuu", this.uuid);
      this.alloWanceList();
    }
  }

  ngOnInit() {

  }

  goBack() {
    this.router.navigate(['/dependence-list']);
  }

  goToUrl() {
    this.router.navigate(['/family-allowance'], { state: { data: '3' } });
  }

  goToResubmit(id) {
    this.router.navigate(['/family-allowance', id], { state: { data: '1' } });
  }



  alloWanceList() {
    console.log("6666666666666666")
    if (this.userDetails && this.userDetails.uuid) {
      var data = {
        uuid: this.userDetails.uuid

      }

    }
    if (this.uuid) {
      console.log("iiiiiiiiiiiiiiiiiii")
      var data = {
        uuid: this.uuid

      }
    }
    if (data) {
      this.ngxUiLoaderService.start();
      this.api.getAllowanceList(data).pipe(first()).subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.response = res;
        console.log("model", this.response);
        if (this.response.status == 200) {
          this.allowanceData = this.response.result;
          console.log("11111111111111", this.allowanceData);

        }
      }, error => {
        this.ngxUiLoaderService.stop();
      });

    }


  }


  getViewAllowanceReports(id) {
    console.log("allowance-id", id);
    this.router.navigate(['/family-allowance-view', id]);
  }

}






